import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBdzI9ZYCqZ9eRa8kiIN3pe04LFDa-EgLI",
  authDomain: "lgsciyiz-e1ad8.firebaseapp.com",
  projectId: "lgsciyiz-e1ad8",
  storageBucket: "lgsciyiz-e1ad8.firebasestorage.app",
  messagingSenderId: "578437456035",
  appId: "1:578437456035:web:67604d86433802af1a1f16",
  measurementId: "G-DEJ0VDZKZC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app; 